module.exports = __webpack_public_path__ + "static/media/3x3 L.565906d9.jpg";